export default class PvApiBadRequestException extends Error {
    constructor() {
        super();
        this.name = '400 bad request';
        this.message = 'Неверный запрос. Возможно введены некоректные данные';
    }
}